import { createIcons, icons } from 'lucide';

function initLucideIcons() {
  createIcons({ icons });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initLucideIcons);

// Re-initialize on Turbo navigation
document.addEventListener('turbo:load', initLucideIcons);
document.addEventListener('turbo:render', initLucideIcons);

// Re-initialize when Turbo frames load content
document.addEventListener('turbo:frame-load', initLucideIcons);
document.addEventListener('turbo:frame-load', initLucideIcons, true);

// Re-initialize when Bootstrap dropdowns are shown (for dynamically loaded content)
document.addEventListener('shown.bs.dropdown', initLucideIcons);

// jQuery fallback for Bootstrap dropdowns
if (typeof $ !== 'undefined') {
  $(document).on('shown.bs.dropdown', initLucideIcons);
}

export { initLucideIcons };
